import {
  GET_EVENEMENTS,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,

  ADD_EVENEMENT_SUCCESS,
  ADD_EVENEMENT_FAIL,
  
  UPDATE_EVENEMENT_SUCCESS,
  UPDATE_EVENEMENT_FAIL,
} from "./actionType";

const INIT_STATE = {
  evenements: [],
  error: {},
};

const Evenement = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EVENEMENTS:
          return {
            ...state,
            evenements: action.payload.data,
            isEvenementCreated: false,
            isEvenementSuccess: true
          };
        
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_EVENEMENTS:
          return {
            ...state,
            error: action.payload.error,
            isEvenementCreated: false,
            isEvenementSuccess: false
          };
        
        default:
          return { ...state };
      }

    case ADD_EVENEMENT_SUCCESS:
      return {
        ...state,
        isEvenementCreated: true,
        evenements: [...state.evenements, action.payload.data],
        isEvenementAdd: true,
        isEvenementAddFail: false
      };

    case ADD_EVENEMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        isEvenementAdd: false,
        isEvenementAddFail: true
      };

    case UPDATE_EVENEMENT_SUCCESS:
      return {
        ...state,
        evenements: state.evenements.map(evenement =>
          evenement.id === action.payload.id
            ? { ...evenement, ...action.payload }
            : evenement
        ),
        isEvenementUpdate: true,
        isEvenementUpdateFail: false
      };

    case UPDATE_EVENEMENT_FAIL:
      return {
        ...state,
        error: action.payload,
        isEvenementUpdate: false,
        isEvenementUpdateFail: true
      };

    default:
      return { ...state };
  }
};

export default Evenement;
